var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('PAGE 404')))]),_c('p',{staticClass:"notification is-info"},[_vm._v(" "+_vm._s(_vm.$t('Not found'))+" "),_c('router-link',{staticClass:"button is-white",attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t('GET BACK HOME')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }